import Vue from 'vue'

import './styles/quasar.scss'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/material-icons-round/material-icons-round.css'
import '@quasar/extras/material-icons-sharp/material-icons-sharp.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/ionicons-v4/ionicons-v4.css'
import '@quasar/extras/mdi-v4/mdi-v4.css'
import '@quasar/extras/eva-icons/eva-icons.css'
import lang from 'quasar/lang/zh-hans.js'
import Quasar from 'quasar/src/vue-plugin.js';import AppFullscreen from 'quasar/src/plugins/AppFullscreen.js';import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Screen from 'quasar/src/plugins/Screen.js';

// 设置周一为每周第1天
lang.date.firstDayOfWeek = 1

// https://quasar.dev/quasar-cli/quasar-conf-js#Property%3A-framework
Vue.use(Quasar, {
  config: {
    notify: {
      position: 'center',
      color: 'primary',
      // timeout: 10000,
      timeout: 2000,
      closeBtn: true,
      iconSize: '30px'
    },
    dark: 'auto'
  },
  plugins: [
    AppFullscreen,
    Notify,
    Dialog,
    Screen
  ],
  lang: lang
})

Screen.setSizes({
  sm: 1024, md: 1366, lg: 1600, xl: 1920
})
